import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  TextField as MuiTextField,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import { useState, useEffect } from "react";
import {
  useCreate,
  useNotify,
  useRefresh,
  useRecordContext,
} from "react-admin";

export const SetupStepCreateDialog = ({ open, onClose }) => {
  const notify = useNotify();
  const refresh = useRefresh();
  const [create, { isLoading }] = useCreate();
  const record = useRecordContext();
  const setupPlanId = record?.id;

  const [step, setStep] = useState({
    title: "",
    order: "",
    skippable: false,
    isActive: true,
  });

  useEffect(() => {
    if (open && record?.setupSteps?.length > 0) {
      const maxOrder = Math.max(...record.setupSteps.map((s) => s.order || 0));
      setStep((prev) => ({ ...prev, order: maxOrder + 1 }));
    } else if (open) {
      setStep((prev) => ({ ...prev, order: 1 }));
    }
  }, [open, record?.setupSteps]);

  const handleChange = (event) => {
    const { name, value, type, checked } = event.target;
    setStep((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSave = () => {
    create(
      "__setupStep",
      {
        data: {
          title: step.title,
          order: step.order,
          skippable: step.skippable,
          isActive: step.isActive,
          setupPlanId,
        },
      },
      {
        onSuccess: () => {
          notify("Step successfully created", { type: "success" });
          refresh();
          handleClose();
        },
        onError: (error) => {
          notify(`Error creating step: ${error.message}`, { type: "error" });
        },
      }
    );
  };

  const handleClose = () => {
    setStep({
      title: "",
      order: "",
      skippable: false,
      isActive: true,
    });
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>Add Setup Step</DialogTitle>
      <DialogContent>
        <MuiTextField
          label="Title"
          name="title"
          fullWidth
          value={step.title}
          onChange={handleChange}
          margin="normal"
        />
        <MuiTextField
          label="Order"
          name="order"
          type="number"
          fullWidth
          value={step.order}
          onChange={handleChange}
          margin="normal"
        />
        <FormControlLabel
          control={
            <Checkbox
              name="skippable"
              checked={step.skippable}
              onChange={handleChange}
            />
          }
          label="Skippable"
        />
        <FormControlLabel
          control={
            <Checkbox
              name="isActive"
              checked={step.isActive}
              onChange={handleChange}
            />
          }
          label="Active"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={isLoading}>
          Cancel
        </Button>
        <Button
          onClick={handleSave}
          disabled={!step.title || step.order === "" || isLoading}
          variant="contained"
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};
